<div class="thin-border">
  <div *ngIf="showDevComments" class="dev-comment">src\app\landowner\components\annual-lease\annual-lease.component.html</div>

  <div class="flx-container" *ngIf="lease">
    <div *ngIf="listing" class="flx-item title">{{ listing.title }}</div>

    <div class="flx-break-large"></div>

    <div class="flx-container">
      <div class="flx-item-vertical-center flex-col1">
        <label class="inline-label" for="name">Name</label>
      </div>
      <div class="flx-item flx-fill">
        <input
          #annualLeaseName
          id="annual-lease-name"
          type="text"
          class="form-control"
          placeholder="Annual lease name"
          name="name"
          required
          maxlength="255"
          [(ngModel)]="lease.name"
          (ngModelChange)="onChange('name', $event)"
        />

        <div class="input-feedback">
          <div *ngIf="fieldValidationResult['name'] && fieldValidationResult['name'].issues.length" class="flx-left">
            <error-list [errorMessages]="this.fieldValidationResult['name'].issues"> </error-list>
          </div>

          <div class="flx-item flx-right char-count">
            <input-char-counter [inputElement]="annualLeaseName" [value]="lease.name"></input-char-counter>
          </div>
        </div>
      </div>

      <div class="flx-break"></div>

      <!-- <div class="flx-item char-count">
        <input-char-counter [inputElement]="annualLeaseName" [value]="lease.name"></input-char-counter>
      </div> -->

      <div class="flx-break-large"></div>

      <div class="flx-item-vertical-center flex-col1">
        <label class="inline-label" for="name">Description</label>
      </div>
      <div class="flx-item flx-fill">
        <textarea
          #annualLeaseDescription
          placeholder="Describe the annual lease"
          name="annual-lease-desc"
          id="annual-lease-desc"
          class="form-control"
          rows="2"
          maxlength="800"
          required="required"
          [(ngModel)]="lease.description"
          (ngModelChange)="onChange('description', $event)"
        ></textarea>
      </div>

      <div class="flx-break"></div>
      <div class="flx-item char-count">
        <input-char-counter [inputElement]="annualLeaseDescription" [value]="lease.description"></input-char-counter>
      </div>

      <div class="flx-break-large"></div>

      <div class="flx-item-vertical-center flex-col1">
        <label for="name">Status</label>
      </div>

      <div class="flx-item" *ngIf="availableStatus">
        <select id="select-annual-lease-status" class="form-control" [(ngModel)]="lease.statusId">
          <!-- Safari Hack -- See https://stackoverflow.com/a/50418271/386619 -->
          <option disabled selected value="null">-- Select Item --</option>

          <option *ngFor="let item of availableStatus" [value]="item.id" [selected]="lease && lease.statusId === item.id">
            {{ item.name }}
          </option>
        </select>
      </div>

      <div class="flx-item-vertical-center flex-col1">
        <label for="name">Maximum Members</label>
        <oapopover
          class="oa-popover"
          [title]="'Maximum Members'"
          [content]="
            'Does her selective name rave behind the expenditure? The monarch scores the card. Its unauthorized storm postulates a bone. An algebra hesitates beside the conscience. A studio extracts the projected tongue. Each nameless scandal strikes next to the idiot.'
          "
        ></oapopover>
      </div>

      <div class="flx-item">
        <select
          id="select-maximumParticipantCount"
          class="form-control"
          name="maximumParticipantCount"
          [(ngModel)]="lease.maxParticipantCount"
        >
          <!-- Safari Hack -- See https://stackoverflow.com/a/50418271/386619 -->
          <option disabled selected value="null">-- Select Item --</option>
          <option
            *ngFor="let option of 1 | range: maximumParticipantCount"
            [value]="option"
            [selected]="lease && lease.maxParticipantCount === option"
          >
            {{ option }}
          </option>
        </select>
      </div>

      <div class="flx-break-large"></div>

      <!-- Jamie and Kristen decided not to move forward with auto-renew at this time. Removing from UI but keeping the auto-renew code in the API and below. -->
      <!-- <div class="flx-item text-center">
        <div class="checkbox">
          <label>
            <input type="checkbox" [(ngModel)]="lease.isRecurring" />
            <span>Available for renewal</span>
          </label>
        </div>
      </div> -->

      <div class="flx-item text-center">
        <div class="checkbox">
          <label>
            <input [disabled]="!proRateEnabled" type="checkbox" [(ngModel)]="lease.allowProRate" />
            <span>Allow Pro Rate</span>
          </label>
        </div>
      </div>

      <!-- Jamie and Kristen decided not to move forward with auto-renew at this time. Removing from UI but keeping the auto-renew code in the API and below. -->

      <!-- <div class="flx-item text-center">
        <div class="checkbox">
          <label>
            <input type="checkbox" [(ngModel)]="lease.autoPayEnabled" />
            <span>Available for auto-pay</span>
          </label>
        </div>
      </div> -->

      <div class="flx-break-large"></div>

      <!-- Begin Lease Price -->
      <div class="flx-item text-center">
        <div>Lease Price</div>
        <div class="input-group">
          <div class="input-group-addon">$</div>
          <integer-input [(value)]="lease.leaseAmount" (valueChange)="onPriceChange($event, 'leaseAmount')"> </integer-input>
        </div>
      </div>
      <!-- End Lease Price -->

      <!-- Commission -->

      <div class="flx-item text-center">
        <div (click)="consolePrint()">Commission</div>

        <percent-input [(value)]="lease.commission"> </percent-input>
      </div>

      <!-- Begin Member Fee -->
      <div *ngIf="membershipFeeEnabled" class="flx-item text-center">
        <div>Member Fee</div>
        <div class="input-group">
          <div class="input-group-addon">$</div>
          <input
            id="input-lease-memberFee"
            type="number"
            class="form-control"
            min="0"
            step="1"
            placeholder="Member Fee"
            [(ngModel)]="lease.membershipAmount"
            (ngModelChange)="onPriceChange($event, 'membershipAmount')"
          />
        </div>
      </div>
      <!-- End Member Fee -->

      <!-- Lease Service Fee -->
      <div class="flx-item text-center">
        <div>Service Fee</div>
        <div class="input-group">
          <div class="input-group-addon">$</div>
          <input
            id="input-lease-service-fee"
            type="number"
            class="form-control"
            min="0"
            step="1"
            placeholder="Service Fee"
            [(ngModel)]="lease.feeAmount"
            (ngModelChange)="onPriceChange($event, 'feeAmount')"
          />
        </div>

        
        <div *ngIf="fieldValidationResult['feeAmount'] && fieldValidationResult['feeAmount'].issues.length"   class="error-text text-center">
          <error-list [errorMessages]="this.fieldValidationResult['feeAmount'].issues"> </error-list>
        </div>

      </div>
      <!-- End Lease Service Fee -->

      <!-- Escalator -->
      <div class="flx-item text-center">
        <div (click)="consolePrint()">Escalator</div>

        <percent-input [(value)]="lease.escalator"> </percent-input>
      </div>

      <div class="flx-break-large"></div>

      <!--  Available Date -->

      <div class="flx-item text-center">
        <div>Available Date</div>
        <oadate-input [name]="'startDateTime'" [(value)]="lease.startDateTime" (dateChange)="onDateChange($event, 'startDateTime')">
        </oadate-input>
      </div>

      <!--  End Date -->
      <div class="flx-item text-center">
        <div>End Date</div>
        <oadate-input [name]="'endDateTime'" [(value)]="lease.endDateTime" (dateChange)="onDateChange($event, 'endDateTime')">
        </oadate-input>
      </div>

      <!-- Begin Renewal Date renewalEnabled -->
      <div class="flx-item text-center">
        <div>Renewal Date</div>
        <oadate-input
          [enabled]="renewalEnabled"
          [name]="'renewalDate'"
          [(value)]="lease.renewalDate"
          (dateChange)="onDateChange($event, 'renewalDate')"
        >
        </oadate-input>
      </div>

      <!-- End  Renewal Date -->

      <!-- Begin  Auto-Renew Notification Days -->
      <div class="flx-item text-center">
        <div>
          Auto-Renew Notification Days

          <oapopover
            class="oa-popover"
            [title]="'Auto-Renew Notification Days'"
            [content]="
              'The number of days before renewal date that the current lessee will be notified that their release will be auto-renewed (if AutoPayEnabled is true).'
            "
          ></oapopover>
        </div>

        <integer-input
          [enabled]="renewalEnabled"
          [(value)]="lease.autoRenewalNotificationDays"
          (valueChange)="onAutoRenewalNotificationDaysValueChange($event)"
        >
        </integer-input>

        <div>
          {{ renewalNotificationDate | date }}
        </div>
      </div>
      <!-- End  Auto-Renew Notification Days -->

      <div class="flx-item text-center" *ngIf="dateValidation && !dateValidation.isValid">
        <div class="text-left" *ngIf="dateValidation && dateValidation.issues && dateValidation.issues.length > 0">
          <div class="oa-error-text" *ngFor="let e of dateValidation.issues">
            {{ e }}
          </div>
        </div>
      </div>

      <div class="flx-break-large"></div>

      <ng-container *ngIf="listingId">
        <div class="flx-item">
          <div class="title text-center">Seasons</div>
        </div>
        <div class="flx-break"></div>

        <!-- Season Lookup Grid Picker -->
        <div class="flx-item flx-item-season-lookup-grid">
          <season-lookup-grid #seasonLookupGrid [lease]="lease" [contextType]="LeaseSeasonGridContextType.Lease"> </season-lookup-grid>

          <div class="text-center">
            <button
              id="add-to-lease-button"
              [disabled]="!addSeasonsToLeaseEnabled"
              class="btn btn-primary btn-round"
              (click)="onSeasonsToLease()"
            >
              Add To Lease
            </button>
          </div>
        </div>

        <div class="flx-item flx-item-lease-season-grid">
          <div style="height: 51px"></div>
          <lease-season-grid
            #leaseSeasonGrid
            (change)="onLeaseSeasonChange($event)"
            [lease]="lease"
            [contextType]="LeaseSeasonGridContextType.Lease"
          >
          </lease-season-grid>
        </div>

        <div class="flx-break"></div>
      </ng-container>

      <div class="flx-break"></div>

      <div class="flx-item" *ngIf="listingId">
        <div *ngIf="selectedLeaseSeason">
          <lease-season-form (cancel)="onLeaseSeasonFormCancel()" (save)="onLeaseSeasonFormSave($event)" [value]="selectedLeaseSeason">
          </lease-season-form>
        </div>
      </div>

      <div class="flx-break"></div>

      <div class="flx-item" *ngIf="listingId">
        <lease-season-grid
          #leaseSeasonGrid
          (selectChange)="onLeaseSeasonSelectChange($event)"
          [lease]="lease"
          [contextType]="LeaseSeasonGridContextType.Listing"
          [title]="'Seasons on other Leases'"
          [hideIfEmpty]="true"
        >
        </lease-season-grid>
      </div>

      <div class="flx-break-large"></div>

   

      <div class="flx-break-large"></div>

      <ng-container *ngIf="lease && lease.id > 0">
        <div *ngIf="isAdmin" class="flx-item">
          <secure-id-copy [value]="lease.secureAlternateId"> </secure-id-copy>
        </div>

        <div *ngIf="isAdmin" class="flx-break"></div>

        <div class="flx-item">
          <row-metadata-view [model]="lease"> </row-metadata-view>
        </div>

        <div class="flx-break-large"></div>
      </ng-container>

      <ng-container *ngIf="lease">
        <div class="flx-item">
          <lease-card [isLandownerAdmin]="true" #leaseCardElement [value]="leaseCard" (purchase)="onLeasePurchase(null)"> </lease-card>
        </div>
        
        <div class="flx-break"></div>

        <div class="flx-item">
          <button [disabled]="refreshingCard" class="btn btn-info" (click)="onRefreshCardClick()">Refresh Card</button>
        </div>

        <div class="flx-break-large"></div>
      </ng-container>

      <ng-container *ngIf="validations && !validations.isValid">
        <div class="flx-item">
          <error-list [errorMessages]="validations.issues"> </error-list>
        </div>

        <div class="flx-break-large"></div>
      </ng-container>
    </div>
  </div>
</div>

<!-- Begin Add Season Lookup Modal -->
<ng-template #addSeasonModal style="top: 20px" let-modal>
  <div class="modal-header" >
    <div class="title">Add Season Lookup</div>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <div class="title text-center modal-title" *ngIf="listing">
      This season lookup will only be available for listing: <strong>{{ listing.title }}</strong>
    </div>
    <season-lookup-form
      [showTitle]="false"
      (cancel)="onCancelSeasonLookup()"
      (add)="onSeasonLookupAdd($event)"
      [value]="selectedSeasonLookup"
      [listingId]="listingId"
    >
    </season-lookup-form>
  </div>
</ng-template>
<!-- End Add Season Lookup Modal -->
